#### Profile Apply extensions

We’ve extended [Profile Apply](/introduction/release-notes#profile-apply) with additional structured information on the [`CandidateProfile`] object:

- `certifications` lists certifications and licences the candidate holds.
- `education.descriptions` adds free-text descriptions to the candidate’s education history.

```graphql
query ($id: String!) {
  candidateProfile(id: $id) {
    education {
      descriptions
    }
    certifications {
      name
      issuingAuthority {
        name
      }
      issued
      effectiveTimePeriod {
        validTo
      }
      descriptions
    }
  }
}
```

```json
{
  "id": "seekAnzPublicTest:candidateProfile:apply:HmvRHVfJ7FBJMz6jPKuCkQ"
}
```

[`candidateprofile`]: /schema/named-type/CandidateProfile
